export var convertInMinutes = hours => hours * 60;
export var calculateDifferenceInMinutes = (timestamp1, timestamp2) => {
  var difference = (timestamp1 - timestamp2) / 1000;
  difference /= 60;
  return Math.round(difference);
};